import { List, ListItem, IconButton, ListItemButton, ListItemIcon, Checkbox, ListItemText, Button, Divider, Typography } from "@mui/material";
import { color } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks/hooks";
import './task.scss'


const Tasks = () => {
    const tasks = useAppSelector((state) => state.user.tasks)
    const progress = useAppSelector((state) => state.user.progress)
    const placement = useAppSelector((state) => state.user.placement)
    const [months, setMonths] = useState<string[]>([])
    const [filteredTask, setFilteredTask] = useState<any[]>([])
    const getMonths = () => {
        var start = moment(placement.Placement_Start);
        var end = moment(placement.Placement_End);

        let months = []

        while (start.isBefore(end)) {
            months.push(start.format("MMM,YYYY"))
            start.add(1, 'month')
        }
        setMonths([...months])
    }
    useEffect(() => {
        getMonths()
    }, [placement.Placement_Start,placement.Placement_End])
    useEffect(() => {
        let task: any[] = []
        for(let elm of tasks){
            if(elm.Due){
                if (months.filter((month: any) => month.split(",").includes(elm.Due))[0]) {
                    task.push(elm)
                }
            }
            else{
                task.push(elm)
            } 
        }
        setFilteredTask([...task])
    }, [months])


    return (
        <div className="listOuterContainer ">
            <div className="pt-3 px-3">
                <h4 className="cardTitle">Tasks(<span className="gray-color">{filteredTask.length > 0 ? filteredTask.length : 0}</span>)</h4>
            </div>
            {
                filteredTask.length > 0 ? <List sx={{ width: '100%', bgcolor: 'background.paper' }} >
                    {filteredTask.map((value: any, index: any) => {
                        const labelId = `checkbox-list-label-${value.id}`;
                        return (
                            <ListItem
                                key={index}
                                secondaryAction={
                                    <Button aria-label="view" variant="contained">
                                        Submit
                                    </Button>
                                }
                                disablePadding
                            >
                                <ListItemButton role={undefined} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={progress.Task_Completed.length > 0 && progress.Task_Completed.split(",").includes(value.TaskId)}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<p className="font-weight-700 m-0">
                                            {value.Title}
                                        </p>}
                                        secondary={
                                            <>
                                                <span style={{
                                                    fontSize: "12px",
                                                    color: "#717684 !important",
                                                    marginRight: "10px"
                                                }}>Due:{value.Due ? <>
                                                    {
                                                        months.filter((elm) => {
                                                            if(elm.split(",").includes(value.Due))
                                                            return elm
                                                        }) 
                                                    }
                                                </> : moment(placement.Placement_End).format("MMM,YYYY")}</span>
                                                <span style={{
                                                    fontSize: "12px",
                                                    color: "#717684 !important"
                                                }}>Credit:{value.Credit}</span>
                                            </>

                                        }
                                    />
                                </ListItemButton>
                            </ListItem>

                        );
                    })}
                </List>
                    :
                    <div className="align-items-center flex h-100 justify-content-center w-100">
                        <p className="subTitle gray-color body-p m-0 ">No Tasks Found</p>
                    </div>
            }
        </div>

    )

}
export default Tasks